// extracted by mini-css-extract-plugin
export default {"social-share-buttons":"_2Ti8h","socialShareButtons":"_2Ti8h","social-share-group":"_2vu7m","socialShareGroup":"_2vu7m","social-share-button":"_3EZbd","socialShareButton":"_3EZbd"};